// extracted by mini-css-extract-plugin
export default {"modal":"nS-z","sharingIconsV2":"oS-z","notificationBox":"pS-z","checkMark":"qS-z","textFrame":"rS-z"};